const getGlobalACPNamespace = () => {
    const global = window;
    const acp = (global.ACP = global.ACP || {});
    return acp;
};

export { getGlobalACPNamespace as g };
//# sourceMappingURL=globalAcpNamespace-f56d6e59.js.map
